import React, { useState, useContext, useEffect } from "react";
import "../style/rechargeSupme.css"; // Import CSS file for styling
import { UserContext } from '../App';
import axiosInstance from './axiosConfig';
import { Combobox } from 'react-widgets';
import ReactLoading from 'react-loading'; // Import ReactLoading for loading indicator
import 'react-widgets/styles.css';
import axios from "axios";
import TransactionHistory from "./TransactionApp_his";

export default function RechargeSupme() {
  const [activeTab, setActiveTab] = useState("nap-tien");
  const [_app, setApp] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [customText, setCustomText] = useState('');
  const [coint, setCoint] = useState(0);
  const [appId, setAppId] = useState(''); // New state for app ID
  const [loading, setLoading] = useState(true); // Loading state
  const [errors, setErrors] = useState({}); // State for error messages
  const { user } = useContext(UserContext);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  useEffect(() => {
    console.log(API_BASE_URL);
    const fetchData = async () => {
      try {
        const res = await axios.get(API_BASE_URL+'/allapp');
        if (res.data.length > 0) {
          setApp(res.data);
          console.log(res.data);
        }
        setLoading(false); // Set loading to false after data is fetched
      } catch (error) {
        console.error('Error fetching app data:', error);
        setLoading(false); // Set loading to false if there's an error
      }
    };
    fetchData();
  }, []);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  const formatNumber = (value) => {
    if (!value) return "";
    return new Intl.NumberFormat("vi-VN").format(value); // Định dạng theo chuẩn Việt Nam
  };
  const formatSurplus = (value) => {
    return value?.toLocaleString('vi-VN');
  };

  const calculateCoin = (amount, item) => {
    if (!item || !item.price) return 0;
    const isRain = item.Name_app?.toLowerCase().includes('rain');
    return isRain ? Number(amount) / Number(item.price) : Number(amount) * Number(item.price);
  };

  const handleChange = (value) => {
    setSelectedItem(value);
    setCoint(Number(calculateCoin(customText, value)));
    console.log(value);
  };

  const handleTextChange = (event) => {
    // const value = event.target.value;
    // setCustomText(value);
    const rawValue = event.target.value.replace(/[^\d]/g, "");
    setCustomText(rawValue); // Lưu giá trị gốc (không định dạng)
    setCoint(Number(calculateCoin(rawValue, selectedItem)));
  };

  const handleAppIdChange = (event) => {
    setAppId(event.target.value);
  };

  const handleSubmit = async() => {
    // Reset errors
    setErrors({});

    // Validate fields
    let hasErrors = false;
    const newErrors = {};

    if (!selectedItem) {
      newErrors.selectedItem = 'Bạn cần chọn ứng dụng.';
      hasErrors = true;
    }
    if (!appId) {
      newErrors.appId = 'Bạn cần nhập ID app của bạn.';
      hasErrors = true;
    }
    if (!customText) {
      newErrors.customText = 'Bạn cần nhập số tiền cần nạp.';
      hasErrors = true;
    }
    if (coint <= 0) {
      newErrors.coint = 'Số tiền nạp không hợp lệ.';
      hasErrors = true;
    }
    // Check if customText exceeds user's surplus
    if (parseFloat(customText) > parseFloat(user?.data[0]?.surplus)) {
      newErrors.customText = 'Số tiền cần nạp vượt quá số dư hiện tại.';
      hasErrors = true;
    }

    if (hasErrors) {
      setErrors(newErrors);
      return;
    }

    // Confirm submission
    const confirmed = window.confirm('Bạn chắc chắn muốn gửi?');
    if (confirmed) {
      setLoading(true);
      // Proceed with submission logic
      try {
        const res = await axios.post(API_BASE_URL+'/add_transaction', {
          UserName: user?.data[0]?.UserName,
          Money: parseFloat(customText), // Ensure correct field name and type
          id_app: selectedItem.Id_app, // Ensure correct field name
          time: new Date().toISOString(), // ISO format for datetime
          numberID: appId,
          surplus:user?.data[0]?.surplus
        });
        setLoading(false);
        user.data[0].surplus=user.data[0].surplus-parseFloat(customText)
        const confirmed_ = window.confirm('Bạn vào app kiểm tra nhé. Thank you!');
        if(confirmed_) {
          window.location.reload();
        }
        // Handle successful response (e.g., show a success message or redirect)

      } catch (error) {
        console.error('Error adding transaction:', error);
        setErrors({ submit: 'Failed to add transaction' });
      }
      // You can add your submission logic here, e.g., sending data to a server
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <ReactLoading type="spin" color="#000" />
      </div>
    );
  }

  return (
    <div className="tab-container container-fluid">
      <div className="row mb-2 gx-2">
        <div className="col-6 text-center">
          <b className="small">Ví tài khoản:</b>
          <b className="text-theme mb-0">
            <span id="moneyMobile"> {formatSurplus(user?.data[0]?.surplus)}</span>
          </b>
        </div>
        <div className="col-6 text-center">
          <b className="small">Hoa hồng:</b>
          <b className="text-theme mb-0">
            <span id="moneyRefMobile"> 0</span>
          </b>
        </div>
      </div>

      <div className="card border-0 mb-4 shadow-md">
        <div className="card-body p-0">
          <ul className="nav nav-tabs border-bottom" id="companynavigation" role="tablist">
            <li className="nav-item">
              <a 
                href="#nap-tien" 
                className={`nav-link ${activeTab === 'nap-tien' ? 'active' : ''}`} 
                onClick={() => handleTabChange('nap-tien')}
              >
                NẠP TIỀN
              </a>
            </li>
          {/* <li className="nav-item">
              <a 
                href="#rut-tien" 
                className={`nav-link ${activeTab === 'rut-tien' ? 'active' : ''}`} 
                onClick={() => handleTabChange('rut-tien')}
              >
                RÚT TIỀN
              </a>
            </li>
            <li className="nav-item">
              <a 
                href="#chuyen-tien" 
                className={`nav-link ${activeTab === 'chuyen-tien' ? 'active' : ''}`} 
                onClick={() => handleTabChange('chuyen-tien')}
              >
                CHUYỂN TIỀN
              </a>
            </li>*/}
          </ul>
        </div>
      </div>
      <div className="row mb-2">
        <div className="col">
          <h2 className="my-4">{activeTab === 'nap-tien' ? 'Nạp tiền vào app' : activeTab === 'rut-tien' ? 'Rút tiền' : 'Chuyển tiền'}</h2>
        </div>
        {/* <div className="col-auto">
          <a href="/lich-su-nap-tien" className="float-end size-12">Lịch sử nạp tiền<i className="bi bi-chevron-right"></i></a>
        </div> */}
      </div>

      <div >
        <div className="card-body py-1">
          <div className="tab-content">
            {activeTab === 'nap-tien' && (
              <div id="nap-tien">
                <div className={`tab-pane fade ${activeTab === "nap-tien" ? "show active" : ""}`} id="atm" role="tabpanel" aria-labelledby="tab1-tab">
                  <div className="row">
                    <div className="col">
                      <div className=" mb-3 w-100">
                        <div>
                          {_app.length > 0 ? (
                            <>
                            <div className="form-container">
                              <Combobox
                                data={_app}
                                textField="Name_app"
                                valueField="Id_app"
                                value={selectedItem}
                                onChange={handleChange}
                                placeholder="Chọn ứng dụng"
                                filter="contains"
                                className="combobox"
                                itemComponent={({ item }) => (
                                  <div>{item.Name_app} - {item.price}</div>
                                )}
                              />
                              {errors.selectedItem && <div className="text-danger">{errors.selectedItem}</div>}
                              <input
                                type="text"
                                value={appId}
                                onChange={handleAppIdChange}
                                placeholder="ID app của bạn"
                                className="form-control mt-3"
                              />
                              {errors.appId && <div className="text-danger">{errors.appId}</div>}
                              <input
                                type="text"
                                value={formatNumber(customText)}
                                onChange={handleTextChange}
                                placeholder="Nhập số tiền cần nạp"
                                className="form-control mt-3"
                              />
                              {errors.customText && <div className="text-danger">{errors.customText}</div>}
                              <input
                                type="text"
                                value={formatNumber(coint)}
                                className="form-control mt-3"
                                readOnly
                              />
                              {errors.coint && <div className="text-danger">{errors.coint}</div>}
                              <button
                                type="button"
                                onClick={handleSubmit}
                                className="custom-button m-3 text-center justify-content-center"
                                style={{maxWidth:"115px"}}
                              >
                                <i className="fas fa-paper-plane mx-1"></i> Gửi
                              </button>
                            </div>
                            <div className="container-fluid">
              
                            <TransactionHistory userName={user?.data[0]?.UserName} />
                            </div>
                            </>
                          ) : (
                            <p>No apps available</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {activeTab === 'rut-tien' && (
              <div id="rut-tien">
                <h4>Rút tiền</h4>
                <p>Nội dung của tab Rút tiền.</p>
              </div>
            )}
            {activeTab === 'chuyen-tien' && (
              <div id="chuyen-tien">
                <h4>Chuyển tiền</h4>
                <p>Nội dung của tab Chuyển tiền.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
